module.exports = __webpack_public_path__ + "media/images/hapier-14174388d924aa4eb774a46a85db5b09.png";